"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaintenanceService = exports.isMaintenanceCached = exports.isMaintenanceInNotificationPeriod = exports.isMaintenanceDowntimeActive = void 0;
var luxon_1 = require("luxon");
function isMaintenanceDowntimeActive(maintenance) {
    var _a = maintenance.currentState, isDown = _a.isDown, downtimeEndDate = _a.downtimeEndDate;
    return isDown && luxon_1.DateTime.fromISO(downtimeEndDate).toMillis() >= luxon_1.DateTime.now().toMillis();
}
exports.isMaintenanceDowntimeActive = isMaintenanceDowntimeActive;
function isMaintenanceInNotificationPeriod(maintenance) {
    var _a = maintenance.currentState, isDown = _a.isDown, notificationsStartDate = _a.notificationsStartDate, notificationsEndDate = _a.notificationsEndDate;
    return !isDown && luxon_1.DateTime.fromISO(notificationsStartDate).toMillis() <= luxon_1.DateTime.now().toMillis()
        && luxon_1.DateTime.fromISO(notificationsEndDate).toMillis() >= luxon_1.DateTime.now().toMillis();
}
exports.isMaintenanceInNotificationPeriod = isMaintenanceInNotificationPeriod;
function isMaintenanceCached(userId, maintenanceId, version) {
    var cachedVersion = localStorage.getItem(userId + "-" + maintenanceId);
    return cachedVersion ? (parseInt(cachedVersion) >= version) : false;
}
exports.isMaintenanceCached = isMaintenanceCached;
function useMaintenanceService(fileApiUrl, userId, appId, tokenProvider) {
    var _this = this;
    if (userId === void 0) { userId = ''; }
    if (tokenProvider === void 0) { tokenProvider = function (url) { return new Promise(function (res) { return res(''); }); }; }
    var getRequest = function (url) {
        return new Promise(function (res, _) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = fetch;
                        _b = [url];
                        _c = { method: 'GET' };
                        _d = {};
                        _e = "Bearer ";
                        return [4 /*yield*/, tokenProvider(url)];
                    case 1:
                        _a.apply(void 0, _b.concat([(_c.headers = (_d.Authorization = _e + (_f.sent()), _d), _c)]))
                            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                            var text;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, response.text()];
                                    case 1:
                                        text = _a.sent();
                                        res(text && JSON.parse(text));
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (err) {
                            console.log("Failed to fetch maintenance info.");
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    var getAll = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getRequest(fileApiUrl + "/api/fileupload/maintenance")];
        });
    }); };
    var getOne = function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getRequest(fileApiUrl + "/api/fileupload/maintenance/" + id)];
        });
    }); };
    var getActive = function () { return __awaiter(_this, void 0, void 0, function () {
        var allMaintenances;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAll()];
                case 1:
                    allMaintenances = _a.sent();
                    return [2 /*return*/, allMaintenances
                            .filter(function (maintenance) {
                            if (!maintenance.apps)
                                return true;
                            return maintenance.apps.includes('all') || maintenance.apps.includes(appId);
                        })
                            .find(function (maintenance) {
                            if (isMaintenanceDowntimeActive(maintenance)) {
                                return true;
                            }
                            else if (isMaintenanceInNotificationPeriod(maintenance)) {
                                return !isMaintenanceCached(userId, maintenance.id, maintenance.version);
                            }
                            return false;
                        })];
            }
        });
    }); };
    var dontShowAgain = function (id, version) {
        localStorage.setItem(userId + "-" + id, version.toString());
    };
    return { getAll: getAll, getOne: getOne, getActive: getActive, dontShowAgain: dontShowAgain };
}
exports.useMaintenanceService = useMaintenanceService;
